// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vegan_toggle {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
@media (min-width: 991px) {
  .vegan_toggle {
    padding: 10px;
  }
}
.vegan_toggle .filter-toggle {
  display: flex;
  align-items: center;
  padding: 5px 10px;
  border-radius: 28px;
  margin-right: 10px;
  cursor: pointer;
}
.vegan_toggle .filter-toggle ion-icon {
  width: 20px;
  height: 20px;
}
@media (min-width: 991px) {
  .vegan_toggle .filter-toggle ion-icon {
    width: 30px;
    height: 30px;
  }
}
.vegan_toggle .filter-toggle p {
  font-size: 14px;
  text-transform: capitalize;
  font-weight: bold;
  color: black;
  padding-left: 5px;
}
@media (min-width: 991px) {
  .vegan_toggle .filter-toggle p {
    font-size: 18px;
  }
}
.vegan_toggle .toggler {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #567E4A;
  box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.2) inset;
  padding: 1.5px 7px;
  border-radius: 50px;
  width: 175px;
  height: 50px;
  position: relative;
}
.vegan_toggle .toggler .toggler_item {
  padding: 0px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: AppFontBold;
  font-size: 12px;
  line-height: 19px;
  color: #34A853;
  transition: all 0.4s;
  cursor: pointer;
  width: 33%;
  text-transform: capitalize;
  color: black;
}
.vegan_toggle .toggler .toggler_item.selected {
  z-index: 10;
}
.vegan_toggle .toggler .toggler_pin {
  position: absolute;
  color: red;
  top: -6px;
  width: 65px;
  height: 65px;
  border-radius: 50%;
  background: var(--ion-color-primary);
  box-shadow: 0px 4px 15px 0px rgba(79, 97, 79, 0.1490196078);
  transition: all 0.3s ease-out;
}
.vegan_toggle .toggler .toggler_pin .pin_img {
  height: 40px;
  width: 40px;
}
.vegan_toggle .toggler .toggler_pin.first {
  left: 0px;
}
.vegan_toggle .toggler .toggler_pin.second {
  left: 56px;
}
.vegan_toggle .toggler .toggler_pin.third {
  left: 110px;
}

.all-item {
  position: relative;
}
.all-item ion-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 40px !important;
  height: 40px !important;
}
.all-item p {
  position: absolute;
  bottom: 20px;
  color: var(--ion-color-secondary);
  font-size: 15px;
  font-family: AppFontBold, sans-serif;
  bottom: 4px;
  text-transform: uppercase;
}

.image-block {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 5px;
}
.image-block ion-icon {
  height: 30px;
}
.image-block .first-img {
  width: 30px !important;
  height: 30px !important;
}
.image-block .second-img {
  width: 25px !important;
  height: 25px !important;
}
.image-block p {
  color: white;
  font-size: 12px;
  font-family: AppFontBold, sans-serif;
  text-transform: uppercase;
}`, "",{"version":3,"sources":["webpack://./src/app/components/menu-filters/menu-filters.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AADJ;ACHE;EDCF;IAKM,aAAA;EACJ;AACF;AACI;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AACN;AAAM;EACE,WAAA;EACA,YAAA;AAER;ACpBE;EDgBI;IAII,WAAA;IACA,YAAA;EAIR;AACF;AAFM;EACE,eAAA;EACA,0BAAA;EACA,iBAAA;EACA,YAAA;EACA,iBAAA;AAIR;ACjCE;EDwBI;IAOI,eAAA;EAMR;AACF;AAHI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EAEA,sDAAA;EAEA,kBAAA;EACA,mBAAA;EAEA,YAAA;EACA,YAAA;EACA,kBAAA;AAEN;AAIM;EACE,YAAA;EAEA,YAAA;EAKA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EAEA,oBAAA;EACA,eAAA;EACA,UAAA;EACA,0BAAA;EACA,YAAA;AARR;AASQ;EACE,WAAA;AAPV;AAaM;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EAEA,kBAAA;EACA,oCAAA;EACA,2DAAA;EAQA,6BAAA;AAnBR;AAoBQ;EACE,YAAA;EACA,WAAA;AAlBV;AAyBQ;EACE,SAAA;AAvBV;AA6BQ;EACE,UAAA;AA3BV;AAgCQ;EACE,WAAA;AA9BV;;AAsCE;EACE,kBAAA;AAnCJ;AAoCI;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,sBAAA;EACA,uBAAA;AAlCN;AAoCI;EACE,kBAAA;EACA,YAAA;EACA,iCAAA;EACA,eAAA;EACA,oCAAA;EACA,WAAA;EACA,yBAAA;AAlCN;;AAsCE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;AAnCJ;AAoCI;EACE,YAAA;AAlCN;AAoCI;EACE,sBAAA;EACA,uBAAA;AAlCN;AAoCI;EACE,sBAAA;EACA,uBAAA;AAlCN;AAoCI;EACE,YAAA;EACA,eAAA;EACA,oCAAA;EAEA,yBAAA;AAnCN","sourcesContent":["@import \"../../../theme/mixins\";\n\n.vegan_toggle {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    @include desktop {\n      padding: 10px;\n    }\n\n    .filter-toggle {\n      display: flex;\n      align-items: center;\n      padding: 5px 10px;\n      border-radius: 28px;\n      margin-right: 10px;\n      cursor: pointer;\n      ion-icon {\n        width: 20px;\n        height: 20px;\n        @include desktop {\n          width: 30px;\n          height: 30px;\n        }\n      }\n      p {\n        font-size: 14px;\n        text-transform: capitalize;\n        font-weight: bold;\n        color: black;\n        padding-left: 5px;\n        @include desktop {\n          font-size: 18px;\n        }\n      }\n    }\n    .toggler {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      background: #567E4A;\n\n      box-shadow: 0px 10px 20px 0px #00000033 inset;\n\n      padding: 1.5px 7px;\n      border-radius: 50px;\n      // width: 120px;\n      width: 175px;\n      height: 50px;\n      position: relative;\n      // @include desktop {\n      //   // width: 183px;\n      //   width: 213px;\n      //   padding: 4px 15px;\n      // }\n      .toggler_item {\n        padding: 0px;\n      \n        height: 100%;\n        // @include desktop {\n        //   padding: 0 7px;\n        //   font-size: 14px;\n        // }\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-family: AppFontBold;\n        font-size: 12px;\n        line-height: 19px;\n        color: #34A853;\n\n        transition: all 0.4s;\n        cursor: pointer;\n        width: 33%;\n        text-transform: capitalize;\n        color: black;\n        &.selected {\n          z-index: 10;\n\n          // color: transparent;\n        }\n      }\n    \n      .toggler_pin {\n        position: absolute;\n        color: red;\n        top: -6px;\n        width: 65px;\n        height: 65px;\n\n        border-radius: 50% ;\n        background: var(--ion-color-primary);\n        box-shadow: 0px 4px 15px 0px #4F614F26;\n\n        // @include desktop {\n        //   top: -3px;\n        //   width: 35px;\n        //   height: 35px;\n        // }\n  \n        transition: all 0.3s ease-out;\n        .pin_img {\n          height: 40px;\n          width: 40px;\n          // @include desktop {\n          //   height: 50px;\n          //   width: 50px;\n          // }\n        }\n    \n        &.first {\n          left:0px;\n          // @include desktop {\n          //   left: 11px;\n          // }\n        }\n    \n        &.second {\n          left: 56px;\n          // @include desktop {\n          //   left: 42px;\n          // }\n        }\n        &.third {\n          left: 110px;\n          // @include desktop {\n          //   left: 72px;\n          // }\n        }\n      }\n    }\n  }\n  .all-item {\n    position: relative;\n    ion-icon {\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n      width: 40px !important;\n      height: 40px !important;\n    }\n    p {\n      position: absolute;\n      bottom: 20px;\n      color: var(--ion-color-secondary);\n      font-size: 15px;\n      font-family: AppFontBold, sans-serif;\n      bottom: 4px;\n      text-transform: uppercase;\n    }\n\n  }\n  .image-block {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    padding-top: 5px;\n    ion-icon {\n      height: 30px;\n    }\n    .first-img {\n      width: 30px !important;\n      height: 30px !important;\n    }\n    .second-img {\n      width: 25px !important;\n      height: 25px !important;\n    }\n    p {\n      color: white;\n      font-size: 12px;\n      font-family: AppFontBold, sans-serif;\n\n      text-transform: uppercase;\n    }\n  }\n ","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
